import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-interactive-activities',
  templateUrl: './interactive-activities.component.html',
  styleUrls: ['./interactive-activities.component.css']
})
export class InteractiveActivitiesComponent implements OnInit {
  @Input() storiesList:any;
  storyData:any;

  constructor(public selfLearnService: SelfLearnService,    private sanitizer: DomSanitizer,
    private cookieService: CookieService,public spinner:NgxSpinnerService,) { }

  ngOnInit(): void {
    console.log(this.storiesList);
  }
  updateStoryProgress(storyId:any){
    let paylaod:any = {
      "examId": this.selfLearnService.getCmsExamID(),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": this.selfLearnService.getSubjectId(),
      "chapterId": this.selfLearnService.getChapterId(),
      "chapterName": this.selfLearnService.getChapterName(),
      "storyId": storyId,
      "timeTakenInSec": 0,
    }
    this.selfLearnService.updateStoryProgress(paylaod).subscribe((res:any) => {
    
    })
  }
  openStory(storyId:any){
    this.updateStoryProgress(storyId);
    this.spinner.show();
    this.selfLearnService.getStoryWithCMSAPI(storyId).subscribe((response:any) => {
      if (response) {
        this.storyData = response?.data;
        this.storyData.storyURL = this.transform(
          this.storyData.storyURL
        );
        let keyPairId =  response?.data?.keyPairId;
        let signature =  response?.data?.signature;
        let policy =  response?.data?.policy;
        const origin = response?.data.storyURL.toString();
        const tempDomain = `.${origin.split('.')?.[1]}.${origin.split('.')?.[2]}`;
        const domain = tempDomain.split('/')[0];
        console.log(domain);
        // this.cookieService.deleteAll('/',domain);
        // this.cookieService.delete("CloudFront-Policy","/",domain,true,"None");
        // this.cookieService.delete("CloudFront-Signature","/",domain,true,"None");
        // this.cookieService.delete("CloudFront-Key-Pair-Id","/",domain,true,"None");

        this.cookieService.set(
          'CloudFront-Policy',
          policy,
          undefined,
          '/',
          domain,
          false,
          null
        );
        this.cookieService.set(
          'CloudFront-Signature',
          signature,
          undefined,
          '/',
          domain,
          false,
          null
        );
        this.cookieService.set(
          'CloudFront-Key-Pair-Id',
          keyPairId,
          undefined,
          '/',
          domain,
          false,
          null
        );
        setTimeout(() => {
          window.open(this.storyData.storyURL.changingThisBreaksApplicationSecurity, "_blank");
          this.spinner.hide();
        }, 1000);
      }
      

    })
    
  }
    transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
